import isInPosDevice from "./isInPosDevice"

const isPosTerminalPayment = (cashTypes) => {
  const isPosPaymentSelected =
    cashTypes.some(cashType => cashType.isTerminal)

  return isInPosDevice() && isPosPaymentSelected
}

export default isPosTerminalPayment